var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.999707C0 0.447449 0.447715 -0.000244141 1 -0.000244141H15C15.5523 -0.000244141 16 0.447449 16 0.999707C16 1.55197 15.5523 1.99966 15 1.99966H1C0.447715 1.99966 0 1.55197 0 0.999707ZM0 5.99946C0 5.44721 0.447715 4.99951 1 4.99951H15C15.5523 4.99951 16 5.44721 16 5.99946C16 6.55172 15.5523 6.99942 15 6.99942H1C0.447715 6.99942 0 6.55172 0 5.99946ZM0 10.9992C0 10.447 0.447715 9.99927 1 9.99927H15C15.5523 9.99927 16 10.447 16 10.9992C16 11.5515 15.5523 11.9992 15 11.9992H1C0.447715 11.9992 0 11.5515 0 10.9992Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.be105c4e4356e41e45a918da6a2134f5.svg";
export { ForwardRef as ReactComponent };